import type { View } from "@novorender/api";

import type { AppDispatch } from "app/store";

import { type PointLine, pointLineActions } from "./pointLineSlice";
import { pushDeleteLineUndoRedo, pushDeletePointUndoRedo } from "./pointLineUndoRedo";

export function handleDeletePointLine(dispatch: AppDispatch, pointLine: PointLine) {
    const lineCopy: PointLine = {
        ...pointLine,
        points: pointLine.points.map((p) => ({ ...p })),
    };
    dispatch(pointLineActions.deletePointlineById(pointLine.id));
    pushDeleteLineUndoRedo(dispatch, lineCopy);
}

export function handleDeleteLineSegment(
    dispatch: AppDispatch,
    view: View | null | undefined,
    pointLine: PointLine,
    deletablePointId?: string,
) {
    if (pointLine.points.length <= 2) {
        handleDeletePointLine(dispatch, pointLine);
        return;
    }
    if (!view || !deletablePointId) {
        return;
    }
    const point = pointLine.points.find((p) => p.id === deletablePointId);
    if (!point) {
        return;
    }
    const pointIdx = pointLine.points.findIndex((p) => p.id === deletablePointId);
    const pointCopy = { ...point };
    dispatch(pointLineActions.deletePointById({ pointLineId: pointLine.id, pointId: deletablePointId }, view));
    pushDeletePointUndoRedo(dispatch, view, pointLine.id, pointCopy, pointIdx, pointLine.reversed);
}
